<app-tab-bar [tabs]="tabList" [currentTab]="'screener'" (updateCurrentIndex)="openTab($event)"></app-tab-bar>
<div class="site-content" (click)="closeAlert()">
  <div class="section">
    <div class="sub-section" *ngIf="dataLoaded">
      <app-screener-filters [indexType]="indexType" (filterStatus)="clearFilter()" (shareFilter)="applyFilterOnEmix($event)"></app-screener-filters>
    </div>
    <div class="sub-section" style="margin-top: 10px">
      <span class="heading-text">Results</span>
      <div class="tab">
        <span class="tablinks activeTab">Indices ({{rowData.length === 0 ? rowData.length : pagingInfo.totalRows}})</span>
      </div>
    </div>
    <div class="sub-section" style="margin-top: 10px">
      <ag-grid-angular
        style="width: 100%;"
        class="ag-theme-balham"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [domLayout]="domLayout"
        (gridReady)="onGridReady($event)"
        (cellMouseOver)="onMouseOver($event)"
        (gridSizeChanged)="onGridSizeChanged()"
        [pagination]="true"
        [paginationPageSize]="pagingInfo.pageSize"
        rowSelection="single"
        (sortChanged)="onSortChanged($event)"
        (selectionChanged)="onRowSelected()">
      </ag-grid-angular>
      <app-custom-tooltip *ngIf="showTooltip" [data]="tooltipData.data" (closeInfo)="closeTooltip()"
                          (mouseleave)="showTooltip = false"
                          style="position: absolute; z-index: 3" [ngStyle]="{'top': tooltipData.event.pageY + 'px', 'left': (tooltipData.event.x + 10) + 'px'}"></app-custom-tooltip>
      <app-pagination-control *ngIf="rowData.length > 0" [input]="this.pagingInfo" (pageChanged)="changePage()"></app-pagination-control>
    </div>
  </div>
</div>
<lib-ihsm-alert-notification class="alert-box" *ngIf="showAlert" [message]="alertMessage" (close)="closeAlert()" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box index-details" *ngIf="showTimeoutAlert" [message]="timeoutMessage" (close)="closeAlert()" [messageType]="alertType"></lib-ihsm-alert-notification>
